import { SupportedBrowser } from "./SupportedBrowser/SupportedBrowser";
import { UnsupportedBrowser } from "./UnsupportedBrowser/UnsupportedBrowser";
import Video from "twilio-video";

export function BrowserTest() {
  const agent = window.navigator.userAgent;
  return (
    <>
      {Video.isSupported && !agent.includes("Firefox") ? (
        <SupportedBrowser />
      ) : (
        <UnsupportedBrowser />
      )}
    </>
  );
}
